import React from 'react'; 
import PropTypes from 'prop-types';
import * as moment from 'moment';
import 'moment/locale/ru';

const HomeCardBig = (props) => {
    const authors = props.data.authors ? props.data.authors.map((item, index) => (<span key={`main_m_author_${item.title}`}>{item.title}{index < props.data.authors.length - 1 ? ',' : ''}</span>)) : [];

    return (
        <article className="home__card home__card_big">
            <div className="card">
                <a href={props.data.href} target="_blank" className="card__link">
                    <span className="card__text">
                        <h4 className="card__text_title">{props.data.title}</h4>
                        <img src={props.data.cover.article} alt={props.data.title} className="mobileImageBig" />
                        <p className="card__text_info">{props.data.summary}</p>
                        {authors.length > 0 ? <div className="authors">{authors}</div> : null}
                        <time className="card__text_date">{moment(props.data.publishTime.sec * 1000).format('LL')}</time>
                    </span>
                    <span className="card__image" style={{ backgroundImage: `url(${props.data.cover.article})` }} />
                </a>
            </div>
        </article>
    );
};

HomeCardBig.propTypes = {
    data: PropTypes.objectOf(PropTypes.any)
};

HomeCardBig.defaultProps = { 
    data: null
};

export default HomeCardBig;



// WEBPACK FOOTER //
// ./src/components/HomeCardBig.jsx